<template>
  <div class="page page-shell">
    <van-nav-bar :title="$t('setting.set_money_pwd')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back" />
      </template>
    </van-nav-bar>

    <div class="content">
      <div class="hero-card">
        <!-- <div class="hero-badge">{{ $t("my.my_statement") }}</div> -->
        <div class="hero-title">{{ $t("setting.set_money_pwd") }}</div>
        <!-- <div class="hero-desc">{{ $t("setting.money_again_place") }}</div> -->
      </div>

      <div class="form-card">
        <div class="field-card" @click="focusOldPassword">
          <div class="field-title">{{ $t("setting.money_place") }}</div>
          <van-password-input
            :value="opw"
            :length="4"
            :gutter="10"
            :focused="oshowKeyboard"
          />
        </div>

        <div class="field-card" @click="focusNewPassword">
          <div class="field-title">{{ $t("setting.money_again_place") }}</div>
          <van-password-input
            :value="tpw"
            :length="4"
            :gutter="10"
            :focused="tshowKeyboard"
          />
        </div>
      </div>

      <van-button class="action-btn" type="primary" @click="setPayPassword()">
        {{ $t("reservation.submit") }}
      </van-button>

      <van-number-keyboard
        v-model="opw"
        :show="oshowKeyboard"
        @input="opw.length !== 3 ? (oshowKeyboard = true) : (tshowKeyboard = true)"
        @blur="oshowKeyboard = false"
      />
      <van-number-keyboard
        v-model="tpw"
        :show="tshowKeyboard"
        @input="tpw.length !== 3 ? (tshowKeyboard = true) : (tshowKeyboard = false)"
        @blur="tshowKeyboard = false"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opw: "",
      tpw: "",
      oshowKeyboard: true,
      tshowKeyboard: false,
      userInfo: {},
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    focusOldPassword() {
      this.oshowKeyboard = true;
      this.tshowKeyboard = false;
    },
    focusNewPassword() {
      this.tshowKeyboard = true;
      this.oshowKeyboard = false;
    },
    setPayPassword() {
      this.oshowKeyboard = false;
      this.tshowKeyboard = false;
      if (this.opw.length !== 4) {
        this.oshowKeyboard = true;
        this.$toast(this.$t("setting.prefect"));
        return false;
      }
      if (this.tpw.length !== 4) {
        this.tshowKeyboard = true;
        this.$toast(this.$t("setting.prefect"));
        return false;
      }
      if (this.opw !== this.tpw) {
        this.$toast(this.$t("setting.prefect"));
        return false;
      }
      this.$http({
        method: "post",
        data: { paypassword: this.opw },
        url: "user_set_paypw",
      }).then((res) => {
        if (res.code === 200) {
          setTimeout(() => {
            this.$toast(res.msg);
          }, 500);
          this.$router.push("Mine");
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.less";

.page-shell {
  min-height: 100%;
  background: #0b0b0d;
}

.content {
  padding: 16px;
}

.hero-card {
  padding: 20px;
  border-radius: 18px;
  border: 1px solid #444;
  background: linear-gradient(to bottom right, #33251a, #1b1435);
  margin-bottom: 16px;
}

.hero-badge {
  display: inline-flex;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 24px;
}

.hero-title {
  margin-top: 12px;
  color: #f4c57d;
  font-size: 36px;
  font-weight: 700;
}

.hero-desc {
  margin-top: 8px;
  color: #ddd;
  font-size: 24px;
}

.form-card {
  padding: 16px;
  border-radius: 18px;
  border: 1px solid #2a2a2a;
  background: #141419;
}

.field-card {
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.03);
  margin-bottom: 14px;
}

.field-card:last-child {
  margin-bottom: 0;
}

.field-title {
  margin-bottom: 12px;
  color: #fff;
  font-size: 26px;
}

::v-deep .van-password-input {
  width: 100%;
  margin: 0;
}

::v-deep .van-password-input__security {
  height: 60px;
}

::v-deep .van-password-input__security .van-password-input__item {
  border: 1px solid #2f2f35;
  border-radius: 14px;
  background: #111015;
}

::v-deep .van-password-input__security i {
  width: 12px;
  height: 12px;
  background-color: #fff;
}

::v-deep .van-number-keyboard {
  background: #15151a;
}

::v-deep .van-key {
  background: #23232b;
  color: #fff;
  border-radius: 12px;
}

.action-btn {
  margin-top: 18px;
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 18px;
  color: #111;
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(to right, #f4c57d, #f5a452);
}
</style>
